import { FC, useEffect } from "react";
import ReactGA from "react-ga4";
import { useAtom } from "jotai";
import { isGAInitialisedAtom } from "~features/tracking/analytics/useIsGAInitialised";
import { useCookieConsent } from "~context/cookieConsentContext";
import { ENABLE_TRACKING_SCRIPTS } from "~features/tracking/trackingConfig";

declare interface DataLayerWindow extends Window {
  GA_INITIALIZED?: boolean;
}
declare const window: DataLayerWindow;

export const GoogleAnalyticsScript: FC = () => {
  const { isAnalyticsAllowed } = useCookieConsent();
  const [isGAInitialised, setGAInitialised] = useAtom(isGAInitialisedAtom);

  useEffect(() => {
    if (
      !isGAInitialised &&
      process.env.GA_MEASUREMENT_ID &&
      ENABLE_TRACKING_SCRIPTS &&
      isAnalyticsAllowed()
    ) {
      ReactGA.initialize(process.env.GA_MEASUREMENT_ID);
      window.GA_INITIALIZED = true;
      setGAInitialised(true);
    }
  }, [isAnalyticsAllowed, isGAInitialised, setGAInitialised]);

  return null;
};
